import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';

import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import SidenavCollapse from './SidenavCollapse';
import { useMaterialUIController } from 'context';
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from './styles/sidenavCollapse';

const SubMenuItem = ({
  icon,
  title,
  subRoutes,
  key,
  collapseName,
  path,
  name,
}) => {
  const [controller] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  const [open, setOpen] = useState(name == 'users');

  const handleClick = () => {
    setOpen(!open);
  };

  const active = subRoutes?.some((route) =>
    collapseName.startsWith(route?.key)
  );

  return (
    <>
      {subRoutes?.length > 0 ? (
        <>
          <ListItemButton
            style={{
              color: 'white',
              width: 'calc(100% - 20px)',
              margin: '0 10px 10px 10px',
            }}
            onClick={handleClick}
            sx={(theme) =>
              collapseItem(theme, {
                active,
                transparentSidenav,
                whiteSidenav,
                darkMode,
                sidenavColor,
              })
            }
          >
            <ListItemIcon
              sx={(theme) =>
                collapseIconBox(theme, {
                  transparentSidenav,
                  whiteSidenav,
                  darkMode,
                  active,
                })
              }
            >
              {icon}
            </ListItemIcon>
            {/* <MDTypography
              sx={(theme) =>
                collapseText(theme, {
                  miniSidenav,
                  transparentSidenav,
                  whiteSidenav,
                  active,
                })
              }
              style={{
                fontSize: '0.875rem',
                fontWeight: '300',
                marginRight: '8px',
              }}
              color="white"
            >
              {title}{' '}
            </MDTypography> */}
            <ListItemText
              primary={title}
              sx={(theme) =>
                collapseText(theme, {
                  miniSidenav,
                  transparentSidenav,
                  whiteSidenav,
                  active,
                })
              }
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          {/* <SidenavCollapse
            name={title}
            icon={icon}
            active={active}
            onClick={handleClick}
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </SidenavCollapse> */}
          <Collapse in={open} timeout="auto" unmountOnExit>
            {subRoutes?.map((subRoute) => {
              if (!subRoute?.displayInSidebar) return null;
              return (
                <NavLink key={subRoute?.key} to={subRoute?.path}>
                  <SidenavCollapse
                    isNested={true}
                    name={subRoute?.name}
                    icon={subRoute?.icon}
                    active={
                      (key === 'dashboard' && collapseName === '') ||
                      collapseName.startsWith(subRoute?.key)
                    }
                  />
                </NavLink>
              );
            })}
          </Collapse>
        </>
      ) : (
        <NavLink key={key} to={path}>
          <SidenavCollapse
            name={name}
            icon={icon}
            active={
              (key === 'dashboard' && collapseName === '') ||
              collapseName.startsWith(key)
            }
          />
        </NavLink>
      )}
    </>
  );
};

SubMenuItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  subRoutes: PropTypes.array,
  key: PropTypes.string,
  collapseName: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
};

SubMenuItem.defaultProps = {
  title: '',
  subRoutes: [],
  key: '',
  collapseName: '',
  path: '',
  name: '',
};

export default SubMenuItem;
